import axios from 'axios';
import { DBMessage, DBName } from '../types';
import config from '../config';

const BACKEND_URL = config.api.url;
const API_BASE_URL = `${BACKEND_URL}/api/admin`;

// Configuration d'axios avec timeout et intercepteur pour le token
const axiosInstance = axios.create({
  timeout: config.api.timeout,
});

// Intercepteur pour ajouter automatiquement le token JWT
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Messages
export const getAllMessages = async (): Promise<DBMessage[]> => {
  const response = await axiosInstance.get(`${API_BASE_URL}/messages`);
  return response.data;
};

export const addMessage = async (text: string): Promise<void> => {
  await axiosInstance.post(`${API_BASE_URL}/messages`, { text });
};

export const updateMessage = async (id: number, text: string): Promise<void> => {
  await axiosInstance.put(`${API_BASE_URL}/messages/${id}`, { text });
};

export const deleteMessage = async (id: number): Promise<void> => {
  await axiosInstance.delete(`${API_BASE_URL}/messages/${id}`);
};

// Noms
export const getAllNames = async (): Promise<DBName[]> => {
  const response = await axiosInstance.get(`${API_BASE_URL}/names`);
  return response.data;
};

export const addName = async (name: string): Promise<void> => {
  await axiosInstance.post(`${API_BASE_URL}/names`, { name });
};

export const updateName = async (id: number, name: string): Promise<void> => {
  await axiosInstance.put(`${API_BASE_URL}/names/${id}`, { name });
};

export const deleteName = async (id: number): Promise<void> => {
  await axiosInstance.delete(`${API_BASE_URL}/names/${id}`);
};
